import React from 'react';
import { useTranslation } from 'react-i18next';
import { FunnelChart, Funnel, Cell, ResponsiveContainer, Tooltip, LabelList } from 'recharts';

const COLORS = ['#0078D4', '#00B7C3', '#8764B8', '#CA5010'];

const FunnelChartWidget = ({ data }) => {
    const { t } = useTranslation();
    const chartData = Array.isArray(data) ? data : [];

    if (chartData.length === 0) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                <p style={{ color: '#999' }}>{t('NO_DATA_AVAILABLE')}</p>
            </div>
        );
    }

    return (
        <ResponsiveContainer width="100%" height="100%">
            <FunnelChart>
                <Tooltip />
                <Funnel dataKey="value" data={chartData} isAnimationActive>
                    <LabelList position="right" fill="#000" stroke="none" dataKey="name" />
                    {chartData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                </Funnel>
            </FunnelChart>
        </ResponsiveContainer>
    );
};

export default FunnelChartWidget;
